import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';

import { AuthenticationService } from './core/authentication/authentication.service';
import { LoaderService } from './core/services/loader.service';
import { NavService } from './core/services/nav.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  isUserAuthenticated: boolean;
  authSubscription: Subscription;
  loaderDisplayed: boolean;
  loaderSubscription: Subscription;
  navOpen: boolean;
  navSubscription: Subscription;

  constructor(private authService: AuthenticationService, private loaderService: LoaderService, private navService: NavService,
             ) {}

  ngOnInit() {
    this.navSubscription = this.navService.navOpen.subscribe((value: boolean) => (this.navOpen = value));
    this.loaderSubscription = this.loaderService.status.pipe(delay(0)).subscribe((value: boolean) => (this.loaderDisplayed = value));
    this.authService.checkIsUserAuthenticated();
    this.authSubscription = this.authService.isUserAuthenticated.subscribe((value: boolean) => {
      this.isUserAuthenticated = value;
    });
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
    this.loaderSubscription.unsubscribe();
    this.navSubscription.unsubscribe();
  }
}
